import { ToolEnum } from './tool.enum';

export const ToolIcons: { [key: string]: string } = {
    [ToolEnum.Select]: 'mouse-pointer',
    [ToolEnum.Hide]: 'eye-slash',
    [ToolEnum.Paint]: 'fill-drip',
    [ToolEnum.Label]: 'tag',
    [ToolEnum.Isolate]: 'hand-point-up',
    [ToolEnum.Fade]: 'lungs',
    [ToolEnum.Position]: 'location-arrow'
};
